import React, { Component } from "react";
import Switch from "rc-switch";
import "rc-switch/assets/index.css";
import { Tooltip } from "reactstrap";
import { defaultColor, themeColorStorageKey } from "../../constants/defaultValues";
import IntlMessages from "../../helpers/IntlMessages";

export default class TopnavDarkSwitch extends Component {
  constructor(props) {
    super(props);
    this.state = {
      switchChecked: false,
      tooltipOpen: false
    };
  }

  componentDidMount() {
    const color = this.getColor();
    // Update the switch state based on the saved theme in localStorage
    this.setState({
      switchChecked: color.indexOf('dark') > -1
    });
  }

  toggle = () => {
    this.setState(prevState => ({
      tooltipOpen: !prevState.tooltipOpen
    }));
  };

  getColor = () => {

    return localStorage.getItem(themeColorStorageKey)
      ? localStorage.getItem(themeColorStorageKey)
      : defaultColor;
  };

  changeMode = () => {
    let color = this.getColor();


    if (color.indexOf('dark') > -1) {
      color = color.replace('dark', 'light');
    } else if (color.indexOf('light') > -1) {
      color = color.replace('light', 'dark');
    }


    localStorage.setItem(themeColorStorageKey, color);

    this.setState({
      switchChecked: color.indexOf('dark') > -1
    }, () => {

      setTimeout(() => {
        window.location.reload();
      }, 500);
    });
  };

  render() {
    return (
      <div className="d-inline-flex align-middle mr-3 flex-dir pb-2" style={{ paddingTop: '14px' }}>
        <span className="dropdown-item pb-0 pt-0">
          <IntlMessages id='dashboards.dark-theme' />
        </span>
        <Switch
          id="Tooltip-Switch"
          className="custom-switch custom-switch-primary custom-switch-small"
          checked={this.state.switchChecked}
          onChange={this.changeMode}
        />
        <Tooltip
          placement="left"
          isOpen={this.state.tooltipOpen}
          target={"Tooltip-Switch"}
          toggle={this.toggle}
        >
          Dark Mode
        </Tooltip>
      </div>
    );
  }
}
